import { render, staticRenderFns } from "./FundsCard.vue?vue&type=template&id=3b322b29&scoped=true"
import script from "./FundsCard.vue?vue&type=script&lang=js"
export * from "./FundsCard.vue?vue&type=script&lang=js"
import style0 from "./FundsCard.vue?vue&type=style&index=0&id=3b322b29&prod&lang=less&scoped=true"
import style1 from "./FundsCard.vue?vue&type=style&index=1&id=3b322b29&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b322b29",
  null
  
)

export default component.exports